import loadable from '@loadable/component';
import Styles from '@fogia/core-web/App/Styles';
import ErrorCatcher from '@fogia/core-web/components/ErrorCatcher';
import SiteMeta from '@fogia/core-web/components/metadata/SiteMeta';
import OrganizationStructuredData from '@fogia/core-web/components/metadata/structuredData/OrganizationStructuredData';
import GTM from '@fogia/core-web/components/Tracking/GTM';
import Site from 'components/Site';

const ScrollRestore = loadable(() => import('@fogia/core-web/components/ScrollRestore'));

const App = () => (
    <ErrorCatcher>
        <GTM />
        <Styles />
        <SiteMeta />
        <OrganizationStructuredData />
        <div id="site-wrapper">
            <Site />
        </div>
        <ScrollRestore />
    </ErrorCatcher>
);

export default App;
